import type { Routes } from '@angular/router';

export const SETTINGS_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    redirectTo: 'my-data',
  },
  {
    path: 'my-data',
    loadComponent: () =>
      import('./settings-my-data/settings-my-data.component').then(
        (m) => m.SettingsMyDataComponent,
      ),
  },
  {
    path: 'password',
    loadComponent: () =>
      import('./settings-password/settings-password.component').then(
        (m) => m.SettingsPasswordComponent,
      ),
  },
] as const;
